module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aries/ari_dir-635d0de67fd18b3e6ee3440558765d4b.gif";